(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7270],{

/***/ 75657:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/online-signature/draw",
      function () {
        return __webpack_require__(55503);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_signature_canvas__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58877);
/* harmony import */ var react_signature_canvas__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_signature_canvas__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8193);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2208);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10447);









const DrawSignature = ()=>{
    var _globalThis_window, _globalThis_window1;
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z);
    const [penColor, setPenColor] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("#000000");
    const [penSize, setPenSize] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(3);
    const [signatureUrl, setSignatureUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [showModal, setShowModal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [screenWidth, setScreenWidth] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(((_globalThis_window = globalThis.window) === null || _globalThis_window === void 0 ? void 0 : _globalThis_window.innerWidth) > 800 ? 700 : ((_globalThis_window1 = globalThis.window) === null || _globalThis_window1 === void 0 ? void 0 : _globalThis_window1.innerWidth) - 50);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handleResize = ()=>{
            var _globalThis_window;
            if (((_globalThis_window = globalThis.window) === null || _globalThis_window === void 0 ? void 0 : _globalThis_window.innerWidth) > 800) {
                setScreenWidth(700);
            } else {
                var _globalThis_window1;
                setScreenWidth(((_globalThis_window1 = globalThis.window) === null || _globalThis_window1 === void 0 ? void 0 : _globalThis_window1.innerWidth) - 50);
            }
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const canvasRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    const clear = ()=>{
        canvasRef.current.clear();
        setSignatureUrl("");
    };
    const openModal = ()=>{
        if (canvasRef.current.isEmpty()) {
            return;
        }
        const dataURL = canvasRef.current.toDataURL("image/png");
        setSignatureUrl(dataURL);
        setShowModal(true);
    };
    const handleDownload = ()=>{
        const link = document.createElement("a");
        link.href = signatureUrl;
        link.download = "signature.png";
        link.click();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "BoloForms Signature Tool - Draw & Download Your eSignature"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "BoloForms Signature Tool - Create your unique digital signature with ease. Use our advanced features to draw your signature or manually select a signature font. Perfect for documents, contracts, and more."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "draw signature, draw signature online, draw signature online free, draw signature online free download, draw signature online free download png, draw signature online free download transparent, draw signature online free download transparent background, draw signature online free download transparent png, draw signature online free download transparent background, draw signature online free download transparent background png, draw signature online free download transparent background free, draw signature online free download transparent background free png, draw signature online free download transparent background free download, draw signature online free download transparent background free download png, draw signature online free download transparent background free download free, draw signature online free download transparent background free download free png, draw signature online free download transparent background free download free download, draw signature online free download transparent background free download free download png, online signature tool"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "generator",
                        content: "BoloForms Signature Tool"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "BoloForms Signature Tool - Draw & Download Your eSignature"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "BoloForms Signature Tool allows you to create your unique digital signature effortlessly. Draw your signature or choose from a selection of signature fonts. Ideal for documents, contracts, and more."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/online-signature/draw"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/online-signature/draw"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col max-w-[1280px] gap-[50px] mx-auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col justify-center items-center text-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-[35px] md:text-[50px] font-bold text-gray-800",
                                children: "Draw your eSignature here"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-[20px] md:text-[25px] text-gray-600 mt-[20px] max-w-[900px]",
                                children: "An online signature generator/maker is a tool that helps you create an online signature. eSignatures are a fast and easy way to sign contracts and legal documents."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col justify-center items-center gap-[50px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: " bg-gray-50 border-[2px] rounded-xl",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_signature_canvas__WEBPACK_IMPORTED_MODULE_5___default()), {
                                    penColor: penColor,
                                    maxWidth: penSize,
                                    ref: canvasRef,
                                    canvasProps: {
                                        width: screenWidth,
                                        height: 200,
                                        className: "sigCanvas"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex justify-center items-center text-center gap-[25px] sm:gap-[50px] text-gray-600",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "",
                                                children: "Color"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex items-center gap-[5px] border border-gray-400 py-[2px] px-[5px] pl-[15px] relative rounded-full",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                        type: "color",
                                                        value: penColor,
                                                        onChange: (e)=>setPenColor(e.target.value),
                                                        name: "",
                                                        id: "",
                                                        className: "border-none outline-none rounded-full w-[25px] h-[30px]"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                        type: "text",
                                                        value: penColor,
                                                        onChange: (e)=>setPenColor(e.target.value),
                                                        maxLength: "7",
                                                        name: "",
                                                        id: "",
                                                        className: "w-[90px] border-none outline-none bg-transparent"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "",
                                                children: "Pen Size"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "range",
                                                min: "1",
                                                max: "10",
                                                value: penSize,
                                                onChange: (e)=>setPenSize(e.target.value),
                                                name: "",
                                                id: "",
                                                className: "w-[120px] sm:w-[200px] accent-violet-600 h-1 cursor-pointer range-sm border-transparent bg-gray-300"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col md:flex-row justify-center items-center gap-[30px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: ()=>clear(),
                                        className: "flex justify-center items-center gap-[3px] bg-transparent text-violet-600 border border-violet-600 text-[18px] font-semibold py-[12px] px-[40px] rounded-full hover:opacity-80",
                                        children: "Clear and draw again"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: ()=>openModal(),
                                        className: "flex justify-center items-center gap-[3px] bg-violet-500 text-white text-[18px] font-semibold py-[12px] px-[40px] rounded-full hover:opacity-80",
                                        children: "Download eSignature"
                                    })
                                ]
                            })
                        ]
                    }),
                    showModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute z-[1000] top-0 left-0 w-full flex justify-center items-start px-[5px] py-[100px] bg-white/50 min-h-screen",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative flex flex-col md:flex-row justify-center items-center w-fit bg-violet-500 mx-auto rounded-2xl",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    onClick: ()=>setShowModal(false),
                                    className: "border border-b-none border-violet-300 shadow-xl absolute top-[-25px] left-[50%] -translate-x-[50%] w-[50px] h-[50px] hover:opacity-90 rounded-full cursor-pointer grid place-items-center bg-white text-violet-600 font-bold text-[20px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_8__/* .AiOutlineClose */ .oHP, {
                                        className: "font-bold"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "lg:w-[500px] md:h-[500px] lg:h-[400px] text-white flex flex-col justify-between gap-[50px] md:gap-[10px] p-[50px] px-[20px] lg:px-[50px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col gap-[15px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-[25px] font-semibold",
                                                    children: "Download Your Signature"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-[18px]",
                                                    children: "Go artistic. Use your mouse or trackpad to make a statement."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-full h-[100px] bg-white p-[10px] flex justify-center items-center rounded-lg relative",
                                                    children: signatureUrl === "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "text-[20px] text-gray-400",
                                                        children: "Your signature will appear here"
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        src: signatureUrl,
                                                        width: 100,
                                                        height: 100,
                                                        className: "w-[50%]",
                                                        alt: ""
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                onClick: ()=>handleDownload(),
                                                className: "bg-white text-violet-600 text-[17px] md:text-[20px] px-[20px] py-[8px] md:px-[40px] md:py-[12px] rounded-full hover:opacity-80",
                                                children: "Download your signature"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-[90%] h-[1px] md:w-[1px] md:h-[350px] bg-white"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "lg:w-[500px] md:h-[500px] lg:h-[400px] text-white flex flex-col justify-between gap-[50px] md:gap-[10px] p-[50px] px-[20px] lg:px-[50px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col gap-[15px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-[25px] font-semibold",
                                                    children: "Take Signatures inside Forms!"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-[18px]",
                                                    children: "Get started for Free"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "",
                                                    children: [
                                                        "Integrated Signatures: Add digital signature fields to your forms for easy signing.",
                                                        "PDF Downloads: Download documents with signatures as PDF files.",
                                                        "Super easy and simple to use."
                                                    ].map((item, index)=>{
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex gap-[10px] text-white",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_8__/* .AiFillCheckCircle */ .mny, {
                                                                        className: "text-[20px]"
                                                                    })
                                                                }),
                                                                item
                                                            ]
                                                        }, index);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                target: "_blank",
                                                href: "https://signature.boloforms.com/login?from=".concat(context.globalData.from || "ONLINE_SIGNATURES_TYPE_DRAW").concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_7__/* .createUTMQueryParams */ .T0)({
                                                    utmData_: context.globalData.utmData,
                                                    from: "ONLINE_SIGNATURES_TYPE_DRAW"
                                                })),
                                                className: "bg-white text-violet-600 text-[17px] md:text-[20px] px-[20px] py-[8px] md:px-[40px] md:py-[12px] rounded-full hover:opacity-80",
                                                children: "Check out BoloForms"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (DrawSignature);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,8877,9774,2888,179], function() { return __webpack_exec__(75657); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);